import React from 'react';
import { useDispatch } from 'react-redux';

import { setBetMatch } from '../../../redux/soccerStoreSlice';

import { FALSE, TRUE } from 'base/utils/soccerHelpers';
import DivButton from 'components/common/DivButton';

type Props = Readonly<{
    numberValue: string;
    lineIndex: number;
    betLinesIndex: number | null;
    selected: boolean;
    disabled: boolean;
}>;

const mapperValue = {
    A0: 0,
    A1: 1,
    A2: 2,
    AM: 3,
    B0: 4,
    B1: 5,
    B2: 6,
    BM: 7,
};

export function SpecialNumber({ numberValue, lineIndex, betLinesIndex, selected, disabled }: Props) {
    const dispatch = useDispatch();

    const handleClick = () => {
        if (disabled) {
            return;
        }

        dispatch(
            setBetMatch({
                betLinesIndex,
                matchIndex: lineIndex,
                pool: mapperValue[numberValue],
                value: !selected ? TRUE : FALSE,
            })
        );
    };

    return (
        <DivButton
            className={`number text-center purchase-line-number purchase-line-chooseable ${selected ? 'selected' : ''}`}
            onClick={handleClick}
        >
            {numberValue.replace('A', '').replace('B', '')}
        </DivButton>
    );
}
